__turbopack_context__.v({
  "dropdown": "index-module__qPPHya__dropdown" + " " + __turbopack_context__.i(23484)["dropdown"],
  "error": "index-module__qPPHya__error" + " " + __turbopack_context__.i(367887)["error"],
  "input": "index-module__qPPHya__input" + " " + __turbopack_context__.i(367887)["input"],
  "label": "index-module__qPPHya__label" + " " + __turbopack_context__.i(367887)["label"],
  "option": "index-module__qPPHya__option" + " " + __turbopack_context__.i(23484)["option"],
  "root": "index-module__qPPHya__root" + " " + __turbopack_context__.i(367887)["root"],
  "section": "index-module__qPPHya__section",
});
